import { createComponent } from '@carvana/merch-components';
import ValueTrackerIcon from '~/icons/ValueTracker';

const ValueTrackerContainer = createComponent('div', {
  className:
    'flex items-center rounded-2xl border border-solid border-grey-2 s:mx-24 s:flex-col m:mx-40 m:flex-row m:py-32 m:pr-32 l:mx-auto l:max-w-[1144px] l:py-24 l:pr-40'
});

export default function ValueTracker() {
  const assetsPath = `${process.env.CVNA_APP_CDN_URL}/merch-assets/rbp/cvt`;

  return (
    <div className="bg-white s:pb-56 m:pb-[104px] l:pb-80">
      <ValueTrackerContainer>
        <div className="s:w-full s:pb-24 s:pt-40 m:mr-44 m:max-w-[290px] m:py-0 l:mr-40 l:max-w-[411px]">
          <picture>
            <source
              srcSet={`${assetsPath}/CVT_Desktop.png`}
              media="(min-width: 1024px)"
            />
            <source
              srcSet={`${assetsPath}/CVT_Tablet.png`}
              media="(min-width: 768px)"
            />
            <img src={`${assetsPath}/CVT_Mobile.png`} alt="Value Tracker" />
          </picture>
        </div>
        <div className="s:px-24 s:pb-48 m:px-0 m:pb-0">
          <div className="flex items-center s:tl-header-xl m:tl-header-m">
            <ValueTrackerIcon />
          </div>
          <h2 className="mb-8 pt-16 font-bold leading-8 tracking-tight text-blue-6 s:text-2xl m:text-[28px]">
            Track the value of your car like a pro
          </h2>
          <p className="text-grey-5 s:tl-body-m m:tl-body-l">
            Looking to sell your car or just curious about its value? Sign up to
            stay dialed.
          </p>
          <p>
            <a
              href="/value-tracker"
              className="underline s:s:tl-body-m m:tl-body-l"
              data-analytics-id="RBR Promo - Value Tracker"
            >
              Get Started
            </a>
          </p>
        </div>
      </ValueTrackerContainer>
    </div>
  );
}
